import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductSaleCostingReportData} from "./product-sale-costing-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductSaleCostingReportModel extends ReportModel<ProductSaleCostingReportData> {
    constructor(injector: Injector) {
        super(injector, ProductSaleCostingReportData);
    }
}
